import React from "react";
import Header from "../Components/Header";
import Rightcontainer from "../Components/Rightcontainer";
import { Link } from "react-router-dom";

const Support = ({ handleShow }) => {
  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = (() => {
    try {
      if (!addsetting) return {};
      const parsed = JSON.parse(addsetting);
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch {
      return {};
    }
  })();

  return (
    <div>
      <div
        className="leftContainer mb_space"
        style={{ minHeight: "100vh", height: "100%" }}
      >

        <div className="pt-5 mt-5  Orher_page_main_section">
          <div className=" ">
            <div className="profile_headings mt-4" style={{color:"white"}}>
              Contact us at below platforms.
            </div>
            <div className="row mt-3">
             

              {/* mail */}
              {/* <div className="col-6 col-lg-4 col-md-3 col-sm-12 mb-3">
                <div className="support_samll_card_btn_type">
                  <a className="cxy flex-column" href="mailto:info@ajsclub.com">
                    <img
                      width="50px"
                      src={process.env.PUBLIC_URL + "/images/mail.png"}
                      alt=""
                    />
                    <span className="">
                      {JSON.parse(localStorage.getItem("sitSetting")) ==
                      "undefined"
                        ? ""
                        : JSON.parse(localStorage.getItem("sitSetting"))
                            ?.supportMail}
                    </span>
                  </a>
                </div>
              </div> */}

              {/* whatsapp */}
              <div className="col-6 col-lg-4 col-md-3 col-sm-12 mb-3">
                <div className="support_samll_card_btn_type">
                  {addCaseSetting?.whatsappSupport ? (
                    <>
                      <a
                    href={addCaseSetting?.whatsappSupport || ""}

                        target="_blank"
                      >
                        <img
                          width="50px"
                          src={process.env.PUBLIC_URL + "/images/whatsapp.png"}
                          alt=""
                        />
                        <span className="">WhatsApp</span>
                      </a>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {/* call */}
              <div className="col-6 col-lg-4 col-md-3 col-sm-12 mb-3">
                <div className="support_samll_card_btn_type">
                  <img
                    width="50px"
                    src={process.env.PUBLIC_URL + "/images/phone.png"}
                    alt=""
                  />
                  <span className="">
                    <a
                      target="_blank"
                      href={`tel:${addCaseSetting?.CompanyMobile || ""}`}

                    >
                      {addCaseSetting?.CompanyMobile || ""}

                    </a>
                  </span>
                </div>
              </div>
              <div className="col-12 col-lg-12 col-md-12 col-sm-12 mb-3">
                <p className="company_address">
                  Address:
                  <span>
                    {addCaseSetting?.CompanyAddress || ""}

                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>


        
      </div>
      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </div>
  );
};

export default Support;
